import Router from '../Router';
import { HomeController } from '../../controllers';

export default class HomeRouter extends Router {
	constructor(args) {
		super(args);

		/**
		 * All routes doesn't required for auth
		 * @type {boolean}
		 */
		this.authOnlyDefault = false;
		/**
		 * Describe where to redirect in case authorized
		 * user will go to pages that has guest only access.
		 * @type {string}
		 */
		this.guestOnlyRedirectUrl = 'my-tips';
	}

	/**
	 * Describe which routes only for guests
	 * and auth user don't have access to them
	 * @return {{home: boolean, registration: boolean}}
	 */
	guestOnly() {
		return {
			home: false,
			registration: true
		}
	}

	initialize(options) {
		this.controller = new HomeController(options);
	}

	get appRoutes() {
		return {
			'(/)': 'home',
			'registration': 'registration',
			'login': 'login',
			'*notFound': 'notFound'
		};
	}
}